import { FileStorageInterface } from './Interfaces/CWA/FileStorageInterface';
import { callAsyncNative } from './NativeFunctions';
import { GetMetadataReplyV1 } from './Interfaces/LSS/GetMetadataReplyV1';
import { GetFileReplyV1 } from './Interfaces/LSS/GetFileReplyV1';
import { Helper } from './Helper';

export class FileStorageClient implements FileStorageInterface {
	public async getFile(
		userId: string,
		storeGuid: string,
		path: string
	): Promise<GetFileReplyV1> {
		const fileAsString = await callAsyncNative<string>('getFile', file => file, userId, storeGuid, path);
		if (fileAsString == null || fileAsString.length === 0) return null;
		return Helper.parseJSON(fileAsString) as GetFileReplyV1;
	}

	public async getAllFiles(
		userId: string,
		storeGuid: string,
		path: string
	): Promise<string[]> {
		const filesAsString = await callAsyncNative<string>('getAllFiles', files => files, userId, storeGuid, path);
		if (filesAsString == null || filesAsString.length === 0) return [];
		return Helper.parseJSON(filesAsString) as string[];
	}

	public async saveFile(
		userId: string,
		storeGuid: string,
		path: string,
		file: string
	): Promise<boolean> {
		return await callAsyncNative<boolean>('saveFile', isFileSaved => isFileSaved, userId, storeGuid, path, file);
	}

	public async deleteFile(
		userId: string,
		storeGuid: string,
		path: string
	): Promise<boolean> {
		return await callAsyncNative<boolean>('deleteFile', isFileDeleted => isFileDeleted, userId, storeGuid, path);
	}

	public async deleteFolder(
		userId: string,
		storeGuid: string,
		path: string
	): Promise<boolean> {
		return await callAsyncNative<boolean>('deleteFolder', isFolderDeleted => isFolderDeleted, userId, storeGuid, path);
	}

	public async getMetadata(
		userId: string,
		storeGuid: string,
		key: string
	): Promise<GetMetadataReplyV1> {
		const metadataAsString = await callAsyncNative('getMetadata', metadata => metadata, userId, storeGuid, key);
		if (metadataAsString == null || metadataAsString.length === 0) return null;
		return Helper.parseJSON(metadataAsString) as GetMetadataReplyV1;
	}

	public async saveMetadata(
		userId: string,
		storeGuid: string,
		key: string,
		value: GetMetadataReplyV1
	): Promise<boolean> {
		return await callAsyncNative('saveMetadata', isMetadataSaved => isMetadataSaved, userId, storeGuid, key, Helper.stringifyJSON(value));
	}

	public async deleteMetadata(
		userId: string,
		storeGuid: string,
		key: string
	): Promise<boolean> {
		return await callAsyncNative('deleteMetadata', isMetadataDeleted => isMetadataDeleted, userId, storeGuid, key);
	}
}
